/** Mirrors hrm PDPStatus. Used by the PDP list filter, badges and grouping. */
export const PDP_STATUSES = [
  { value: 'active', label: 'Active' },
  { value: 'completed', label: 'Completed' },
] as const;

export type PdpStatusValue = (typeof PDP_STATUSES)[number]['value'];

export const pdpStatusLabel = (s: string): string =>
  PDP_STATUSES.find((x) => x.value === s)?.label ?? s;

export function pdpStatusVariant(
  s: string,
): 'default' | 'secondary' | 'destructive' | 'outline' {
  if (s === 'active') return 'default';
  if (s === 'completed') return 'secondary';
  return 'outline';
}
